import styled from "styled-components/macro";

export const PreflightContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "isPreflightRunning",
})`
  display: flex;
  flex-direction: ${(p) => (p.isPreflightRunning ? "row" : "column")};
  flex-wrap: ${(p) => (p.isPreflightRunning ? "wrap" : "nowrap")};
  justify-content: space-between;
  align-items: ${(p) => "flex-end"};
  width: 100%;
  gap: 20px;
  margin-top: 8px;
  .check-approved {
    path {
      fill: var(--success-color);
    }
  }

  .warning {
    path {
      fill: var(--warning-color);
    }
  }
`;

export const LeftSide = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "isPreflightRunning",
})`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1 auto;
  width: ${(p) => (p.isPreflightRunning ? "auto" : "100%")};
  overflow-wrap: break-word;
  overflow: hidden;

  .feedback-tag {
    display: flex;
    align-items: center;
    padding: 8px 10px 8px 10px;
    border-radius: 8px;
    border: 1px solid var(--grey-3);
    gap: 6px;
    word-break: break-word;
    flex-direction: row;
    svg {
      width: 26px;
      height: 26px;
      flex-shrink: 0;
    }
    span {
      line-height: 1.5;
      font-size: 16px;
    }
  }

  .feedback-estimates {
    /* Ensure SVG and content div are side by side */
    display: flex;
    align-items: center;

    /* Style for the wrapper div that will contain all spans */
    .estimates-content {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      min-width: 0;
      flex: 1;

      /* Apply custom behavior for interpunkt/separator */
      span:nth-child(2) {
        /* Interpunkt should not wrap to its own line */
        flex-grow: 0;
        flex-shrink: 1;
        margin: 0 8px; /* Add horizontal spacing around the interpunkt */

        /* Only show interpunkt when it fits on the same line as other content */
        @media (max-width: 580px) {
          display: none;
        }
      }

      /* When the container is narrow, stack the spans */
      @media (max-width: 580px) {
        span:not(:nth-child(2)) {
          flex-basis: 100%;
          margin-top: 4px;
        }
      }
    }
  }
`;

export const RightSide = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "isPreflightRunning",
})`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
  margin-left: ${(p) => (p.isPreflightRunning ? "auto" : "0")};
  min-width: 0;
  max-width: 100%;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CancelLink = styled.a`
  color: #999;
  margin-right: 8px;
  cursor: pointer;
`;

export const SuggestionLink = styled.a`
  display: inline;
  color: var(--primary-cta-high-contrast);
  cursor: pointer !important;
  font-weight: 500;
  text-decoration: none;
  padding: 2px 4px;
  border-radius: 4px;
  &:hover {
    text-decoration: none;
    background-color: var(--menu-color-active);
  }
`;
